// List and Grid View

(function () {
  "use strict";

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCollectionView);
  } else {
    initCollectionView();
  }

  function initCollectionView() {
    const viewToggles = document.querySelectorAll(".view-toggle");
    const productsContainer = document.querySelector(
      "[data-products-container]"
    );

    if (!productsContainer) return;

    const savedView = localStorage.getItem("collection-view") || "grid";
    setView(savedView);

    viewToggles.forEach((toggle) => {
      toggle.addEventListener("click", function () {
        const view = this.dataset.view;
        setView(view);
        localStorage.setItem("collection-view", view);
      });
    });

    function setView(view) {
      if (view === "list") {
        productsContainer.classList.remove(
          "grid",
          "grid-cols-2",
          "md:grid-cols-3",
          "lg:grid-cols-4"
        );
        productsContainer.classList.add("flex", "flex-col");

        const productCards = productsContainer.querySelectorAll("article");
        productCards.forEach((card) => {
          card.classList.add("list-view");
        });
      } else {
        productsContainer.classList.remove("flex", "flex-col");
        productsContainer.classList.add(
          "grid",
          "grid-cols-2",
          "md:grid-cols-3",
          "lg:grid-cols-4"
        );

        const productCards = productsContainer.querySelectorAll("article");
        productCards.forEach((card) => {
          card.classList.remove("list-view");
        });
      }

      viewToggles.forEach((toggle) => {
        const isActive = toggle.dataset.view === view;

        if (isActive) {
          toggle.classList.add(
            "border-brand-500",
            "bg-brand-500/10",
            "text-brand-500"
          );
          toggle.classList.remove("border-gray-800");
          toggle.setAttribute("aria-pressed", "true");
        } else {
          toggle.classList.remove(
            "border-brand-500",
            "bg-brand-500/10",
            "text-brand-500"
          );
          toggle.classList.add("border-gray-800");
          toggle.setAttribute("aria-pressed", "false");
        }
      });
    }
  }
})();
